// Sidebar identity — logo and name (ADR-0164). The server already shapes
// GET /organizations/me per role — callerBrand for a brand manager or a
// single-brand jefe/supervisor, the org logo, the default brand's logo —
// so the client walks one fixed chain and never branches on the role:
//
//   [callerBrand?.logoUrl, logoUrl, defaultBrandLogoUrl]
//     → drop empties → dedupe (order kept)
//
// The sidebar renders the first candidate that loads and falls back to
// the initials when none does.
//
// The name walks the same shape: callerBrand?.name → the organization's
// own name → «Sin organización». For a brand manager, a supervisor or a
// jefe whose stores share one brand, that brand is "their organization";
// a null/absent callerBrand lands on the organization name — there is no
// default-brand fallback.

import type { MyOrganizationResponse } from "@bitacorapro/api-types";

export function orgMarkCandidates(org: Partial<MyOrganizationResponse> | undefined): string[] {
  if (!org) return [];
  const chain = [org.callerBrand?.logoUrl, org.logoUrl, org.defaultBrandLogoUrl];
  const out: string[] = [];
  for (const url of chain) {
    if (typeof url !== "string" || url.trim() === "") continue;
    if (!out.includes(url)) out.push(url);
  }
  return out;
}

export function orgDisplayName(
  org: Pick<Partial<MyOrganizationResponse>, "callerBrand"> | undefined,
  organizationName: string | null | undefined
): string {
  for (const name of [org?.callerBrand?.name, organizationName]) {
    if (typeof name === "string" && name.trim() !== "") return name;
  }
  return "Sin organización";
}
